import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
	html {
		font-size: 16px;
	}

	body {
		background-color: ${({ theme }: any) => theme.colors.background};
		color: ${({ theme }: any) => theme.colors.text};
		font-family: ${({ theme }) => theme.fonts.main};
		font-size: 1rem;
	}

	* { 
		padding: 0;
		margin: 0;
	}
`

export default GlobalStyle
